import { useEffect, useState, useCallback } from 'react';

export function usePWAInstall() {
  const [prompt, setPrompt] = useState<any>(null);

  useEffect(() => {
    const handler = (e: any) => {
      e.preventDefault();
      setPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = useCallback(async () => {
    if (!prompt) {
      console.log('Install not available');
      return false;
    }

    prompt.prompt();
    const choice = await prompt.userChoice;

    setPrompt(null);

    return choice?.outcome === 'accepted';
  }, [prompt]);

  return {
    handleInstall,
    canInstall: !!prompt,
  };
}
